import React, { useEffect, useState } from 'react';
import CartsView from './CartsView'
import { addItemToCrosssell, addToCart, clearOrder, getCrosssellProducts, getOrderCache, order_key, removeFromCart, setOrderCache } from '../../utils/order_cache';
import { callCartItemListeners, callRefreshMyOrderListeners, getAppCfg, getCurrencyCode, sortCartByProductName } from '../../utils/common'
import crmservices from '../../wsclient/';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import PaymentForm from './PaymentForm';
import OrderResultController from './OrderResultController';
import VNPay from './VNPayInitOrder';
import { paths, portalCfg } from '../../../portal.router.config';
import { newGUID } from '../../utils/util';
import Loading from '../../components/Loading';
import { domainName } from '../../../portal.config';
import { aynaottservices } from '../../wsclient/crmservices/aynaottservices';
import { eventTypeSimple, googleAnalytics } from '../../intergrations/google.analytics';

function CartsController(props) {
    const [carts, setCarts] = useState(getOrderCache(order_key.cart));
    const [showAddNote, onShowAddNote] = useState(false);
    const [request_amount_from_wallet_funds, setRequestAmountFromWalletFunds] = useState(props.request_amount_from_wallet_funds);
    const [isValidAmountWalletFund, setIsValidAmountWalletFund] = useState(props.isValidAmountWalletFund);
    const [edit_amount_form, setEditAmountForm] = useState(false);
    const [input_field_value, setInputFieldValue] = useState(0);
    const [message, setMessage] = useState({});
    const [crosssellProducts, setCrosssellProducts] = useState(null);
    const [loadingCrosssell, onLoadingCrosssell] = useState(false);
    const [payment_method_type, setPaymentMethodType] = useState(props.paymentMethod ? props.paymentMethod : "CASH");
    const [payment_method_types, setPaymentMethodTypes] = useState(props.order_type == 'PICK_UP' || props.order_type == 'DIRECT_SALE' ? getOrderCache(order_key.pick_up_store).payment_method_types : getOrderCache(order_key.delivery_fulfilled_by).payment_method_types);
    const estimate_cart_items = getOrderCache(order_key.estimate_cart_item);

    //proceed order
    const [order_result, setOrderResult] = useState(null);
    const [active, setActive] = useState('main');
    const [orderSummary, setOrderSummary] = useState({})
    const [showLoading, onShowLoading] = useState(false);
    const [showPaymentForm, onShowPaymentForm] = useState(false);
    const [paymentFormData, setPaymentFormData] = useState(null);
    const [paymentSelected, setPaymentSelected] = useState(null);
    const currency_code = getCurrencyCode();

    console.log("paymentMethod===", props.paymentMethod);
    console.log("payment_method_types===", payment_method_types);

    useEffect(() => {
        if(payment_method_types && payment_method_types.length > 0)
        {
            if (payment_method_types && payment_method_types.length == 1) {
                setPaymentMethodType(payment_method_types[0])
            } else if(payment_method_types.includes('CASH')){
                setPaymentMethodType('CASH');
                props.onNext('CASH');  
            }
        }
        if(props.primary_card){
            setPaymentMethodType('CARD');
            props.onNext('CARD');
            setPaymentSelected(props.primary_card.id);
        }else if(props.primary_paypal){
            setPaymentMethodType('WALLET');
            props.onNext('WALLET');
            setPaymentSelected(props.primary_paypal.id);
        }
        if(domainName === 'ayna' && document._portalConfig.usePaymentLocal){
            setPaymentMethodType('CASH');
            props.onNext('CASH');
        }
        onLoadCrosssellProductInfor();
    }, [])

    const onLoadCrosssellProductInfor = async () => {
        onLoadingCrosssell(true);
        var crosssellProducts = getCrosssellProducts();

        var fullCrosssellsInformation = []
        let orderFulfillment = null;
        let order_type = getOrderCache(order_key.order_type, true);
        if (order_type) {
            orderFulfillment = order_type == 'PICK_UP' ? getOrderCache(order_key.pick_up_store) : getOrderCache(order_key.delivery_fulfilled_by);
        }
        if (crosssellProducts.length > 0) {
            try {
                for (let i = 0; i < crosssellProducts.length; i++) {
                    var product = crosssellProducts[i];
                    // console.log('product======',product)
                    var productInfoResult = await crmservices.orders.getProductDetail(product.id, {
                        supply_method: order_type,
                        fulfilled_by: orderFulfillment && orderFulfillment.id ? orderFulfillment.id : null, 
                    });
                    if (productInfoResult.code == 'OK') {
                        product = { ...product, ...productInfoResult.data };
                    }
                    fullCrosssellsInformation.push(product);
                }
            } catch (error) {
                console.log("onLoadCrosssellProductInfor exception: ", error);
            }
        }
        //console.log('AAAAAAAAAAAAAAAAAAAAAAAAAA crosssellProducts detail:',fullCrosssellsInformation)
        setCrosssellProducts(fullCrosssellsInformation);
        onLoadingCrosssell(false);
    }

    const onRemoveItem = async (item) => {

        await removeFromCart(item)
        var carts = getOrderCache(order_key.cart);
        //console.log('onRemoveItem==carts=',carts)
        setCarts(carts)
        if (carts.length == 0) {
            props.setActivePage("menu");
            addItemToCrosssell([])
        } else {
            props.onEstimateOrder(null, null, null, true);
            onLoadCrosssellProductInfor()
            setRequestAmountFromWalletFunds(undefined);
            setInputFieldValue(0);
        }
        callCartItemListeners();
    }

    const handleChangeNumberFund = (value) => {
        validateAmountWalletFunds(value)
        setInputFieldValue(value);
    }

    const validateAmountWalletFunds = (value) => {
        var request_amount_from_wallet_funds = value;
        var estimate_order_result = getOrderCache(order_key.estimate_order_result)
        if (request_amount_from_wallet_funds != undefined && request_amount_from_wallet_funds != null) {
            // var suggestWalletFundsAmount = estimate_order_result.invoice_estimate && estimate_order_result.invoice_estimate.wallet_funds_amount ? estimate_order_result.invoice_estimate.wallet_funds_amount : 0;
            if (request_amount_from_wallet_funds > props.availabelWalletFund) {
                setIsValidAmountWalletFund(false);
            } else {
                setIsValidAmountWalletFund(true);
            }
        }
    }

    const onPlaceOrder = async () => {
        onShowLoading(true);
        // console.log('note===',note)
        if (isValidAmountWalletFund == false) {
            showMessage(true, t('REQUEST_WALLET_FUNDS_AMOUNT_INVALID'))
            return;
        }
        await props.onEstimateOrder();// esstimate because check add notes cart


        if (props.request_amount_from_wallet_funds != undefined && props.isUseWalletFund) {
            var wallet_funds_amount = Number(props.request_amount_from_wallet_funds)
            if (wallet_funds_amount != undefined) {
                props.setRequestAmountFromWalletFunds(wallet_funds_amount);
                props.setValidAmountWalletFund(isValidAmountWalletFund)
            }
        }

        var estimate_order_result = getOrderCache(order_key.estimate_order_result);
        let payWithPaygate = true;
        if(estimate_order_result && estimate_order_result.invoice_estimate && payment_method_type == 'CARD' && paymentSelected){
            payWithPaygate = true;
        } else {
            payWithPaygate = false;
        }
        let isAllow = true;
        if(payment_method_type == 'CARD' && !paymentSelected) {
            isAllow = false;
        } 
        if (!isAllow && orderSummary.amountDue == 0) {
            isAllow = true;
        }
        if(isAllow) {
            if (estimate_order_result && estimate_order_result.id) {
                // props.setActivePage('order_preview');
                if (props.order_type === 'DIRECT_SALE' || payWithPaygate == false) {
                    //if portal is ayna => call api mw for payment paygate (ayna ott)
                    if(domainName === 'ayna' && document._portalConfig.usePaymentLocal){
                        await processOrderPaygate();
                    }
                    else await processOrder();
                } else props.setActivePage('order_preview');
            } else {
                props.onEstimateOrder();
            }
        } else {
            showMessage(true, t('invalid_card'));
        }
        onShowLoading(false);
    }

    const onUseWalletFund = async () => {

        const { isUseWalletFund, setUseWalletFund, setAvailabelWalletFund, setRequestAmountFromWalletFunds } = props;
        var use_wallet_funds = undefined;
        if (isUseWalletFund == undefined) {
            use_wallet_funds = true;
        } else {
            use_wallet_funds = !isUseWalletFund;
        }
        var estimate_result = await props.onEstimateOrder(use_wallet_funds);
        var availabelWalletFund = 0;
        if (use_wallet_funds) {
            let isValidateWallet = isValidateUsingWallet();
            if (isValidateWallet) {
                use_wallet_funds = true;
                availabelWalletFund = estimate_result.invoice_estimate && estimate_result.invoice_estimate.wallet_funds_amount ? estimate_result.invoice_estimate.wallet_funds_amount : 0
            } else {
                use_wallet_funds = false;
                showMessage(true, t('WALLET_FUND_INSUFFICIENT'))
            }
            setUseWalletFund(use_wallet_funds);
            setAvailabelWalletFund(availabelWalletFund);
            setInputFieldValue(availabelWalletFund);
            setRequestAmountFromWalletFunds(props.request_amount_from_wallet_funds);
            setIsValidAmountWalletFund(undefined);
        }
        else{
            setUseWalletFund(use_wallet_funds);
            setAvailabelWalletFund(undefined);
            setInputFieldValue(undefined);
            setRequestAmountFromWalletFunds(undefined);
            setRequestAmountFromWalletFunds(undefined);
            setIsValidAmountWalletFund(undefined);
        }
    }

    const isValidateUsingWallet = () => {
        const app_config = getAppCfg();
        let allow_full_basket_wallet_fund = app_config.features && app_config.features.ordering_details ? app_config.features.ordering_details.allow_full_basket_wallet_fund : false;
        let isValidateWallet = true;
        let _estimate_order_result = getOrderCache(order_key.estimate_order_result)
        if (allow_full_basket_wallet_fund) {
            let order_summary = dataUtil.getOrderSummary(_estimate_order_result);
            let totalAmount = order_summary.amountDue;
            let walletFundAmount = order_summary.wallet_funds_amount;
            if (totalAmount > walletFundAmount) {
                isValidateWallet = false
            }
        }
        return isValidateWallet;
    }

    const onShowEditWalletFundAmount = async (type) => {
        if (type === 'save') {
            setRequestAmountFromWalletFunds(input_field_value)
            props.setValidAmountWalletFund(isValidAmountWalletFund);
            if(!input_field_value || input_field_value === '0' || input_field_value === 0){
                props.setRequestAmountFromWalletFunds(undefined);
                props.setUseWalletFund(false);
                await props.onEstimateOrder(false)
            }
            else {
                props.setRequestAmountFromWalletFunds(input_field_value);
                await props.onEstimateOrder(null, null, input_field_value)
            }
        }
        else if (type === 'cancel') {
            setInputFieldValue(0)
        }
        setEditAmountForm(!edit_amount_form)
    }

    const showMessage = (status, message) => {
        setMessage({
            show: status,
            content: message ? message : null
        })
    }

    const onChangePaymentMethod = async(type) => {
        setPaymentMethodType(type);
        await props.onNext(type);
    }
    const onItemQuantityChange = async (product, increase) =>{
       
        await removeFromCart(product)
        var quantity = product.quantity;
        var components = product.components ? product.components : [];
        if (increase) {
            quantity = quantity + 1;
        } else {
            if (quantity > 0) {
                quantity = quantity - 1;
            }
        }
        product.quantity = quantity;
        if (components.length > 0) {
            components = components.map(component => {
                component = { ...component, quantity: quantity };
                return component;
            })
            product.components = components;
        }
        console.log("product:", product);
        if (quantity > 0) {
            await addToCart(product)
        }



        var carts = getOrderCache(order_key.cart);
        //console.log('onRemoveItem==carts=',carts)
        setCarts(carts)
        if (carts.length == 0) {
            props.setActivePage("menu");
            addItemToCrosssell([])
        } else {
            await props.onEstimateOrder(null, null, null, true);
            onLoadCrosssellProductInfor()
            setRequestAmountFromWalletFunds(undefined);
            setInputFieldValue(0);
        }
        callCartItemListeners();
    }
    const processOrder = async () => {
        const { isUseWalletFund, requestAmountFromWalletFunds, setActivePage, paymentMethod, primary_card, primary_paypal } = props;
        onShowLoading(true);
        let estimate_order_result = getOrderCache(order_key.estimate_order_result);

        var payload = {
            estimation_id: estimate_order_result.id,
            use_wallet_funds: isUseWalletFund
        }
        // debugger;
        var order_summary = await dataUtil.getOrderSummary(estimate_order_result, payload.use_wallet_funds, requestAmountFromWalletFunds, true)
        // console.log('request_amount_from_wallet_funds===', request_amount_from_wallet_funds)
        if (requestAmountFromWalletFunds != undefined && payload.use_wallet_funds) {
            // console.log('wallet_funds_amount===', request_amount_from_wallet_funds)
            payload.wallet_funds_amount = Number(requestAmountFromWalletFunds)
        }
        if(isUseWalletFund && input_field_value) payload.wallet_fund_amount = Number(input_field_value);
        //order 3D check
        if(primary_paypal && paymentMethod === 'WALLET'){
            payload.payments = [{ 
                payment_method_type: 'WALLET',
                payment_method_id: primary_paypal.id,
            }];
            try {
                var result = await crmservices.orders.makeOrder(payload);
                if (result.code == 'OK') {
                    var orderResult = result.data;
                    var orderDetail = await crmservices.orders.getOrder(result.data.id);
                    if (orderDetail.code === 'OK') {
                        orderResult.key_dates = orderDetail.data.key_dates;
                        orderResult.total_cost = orderDetail.data.total_cost
                    }
                    googleAnalytics.sendLogEvents(eventTypeSimple.purchase, {
                        amount: order_summary.amountDue,
                        value: order_summary.amountDue,
                        currency: orderDetail && orderDetail.currency ? orderDetail.currency : currency_code,
                    })
                    setOrderCache(order_key.order_status, 'DONE', true)
                    setOrderResult(orderDetail.data);
                    setActive('order_result');
                } else if (result.code == 'MINIMUM_ORDER_AMOUNT_NOT_REACHED') {
                    showMessage(true, t('MINIMUM_ORDER_AMOUNT_NOT_REACHED'))
                } else if (result.code == 'CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION') {
                    showMessage(true, t('CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION'));
                } else {
                    showMessage(true, t('EXCEPTION_PROCESS'));
                }
            } catch (error) {
                console.log("make order exception:", error);
                showMessage(true, t('EXCEPTION_PROCESS'));
            }
        }else if (paymentMethod === 'CASH' || !order_summary.amountDue) {            
            payload.payments = [{ payment_method_type: 'CASH' }]
            if (!order_summary.amountDue) {
                payload.payments = [{ payment_method_type: 'CASH', amount: 0 }]
            }
            try {
                let result = await crmservices.orders.makeOrder(payload);
                if (result.code == 'OK') {
                    let orderResult = result.data;
                    await delay(4000);
                    let orderDetail = await crmservices.orders.getOrder(result.data.id);
                    if (orderDetail.code === 'OK') {
                        orderResult.key_dates = orderDetail.data.key_dates;
                        orderResult.total_cost = orderDetail.data.total_cost
                    }
                    googleAnalytics.sendLogEvents(eventTypeSimple.purchase, {
                        amount: order_summary.amountDue,
                        value: order_summary.amountDue,
                        currency: orderDetail && orderDetail.currency ? orderDetail.currency : currency_code,
                    })
                    setOrderCache(order_key.order_status, 'DONE', true)
                    setOrderResult(orderDetail.data);
                    setActive('order_result');
                } else if (result.code == 'MINIMUM_ORDER_AMOUNT_NOT_REACHED') {
                    showMessage(true, t('MINIMUM_ORDER_AMOUNT_NOT_REACHED'))
                } else if (result.code == 'CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION') {
                    showMessage(true, t('CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION'));
                } else {
                    showMessage(true, t('EXCEPTION_PROCESS'));
                }
            } catch (error) {
                console.log("make order exception:", error);
                showMessage(true, t('EXCEPTION_PROCESS'));
            }
            //order 3D check
        }
        else if (paymentMethod === 'VNPAY') {
            payload.payments = [{ payment_method_type: 'CASH' }]
            setOrderCache(order_key.cache_order_to_be_process, payload);
            setOrderSummary(order_summary);
            setActive('vnpay');
        }
        else {
            //check with card and card is stripe
            if (primary_card && primary_card.name && (primary_card.name.toLowerCase() === 'stripe' || primary_card.name.toLowerCase() === 'paygate')) {
                payload.payments = [{ 
                    payment_method_type: 'CARD',
                    payment_method_id: primary_card.id,
                }];
                try {
                    let result = await crmservices.orders.makeOrder(payload);
                    if (result.code == 'OK') {
                        let orderResult = result.data;
                        let orderDetail = await crmservices.orders.getOrder(result.data.id);
                        if (orderDetail.code === 'OK') {
                            orderResult.key_dates = orderDetail.data.key_dates;
                            orderResult.total_cost = orderDetail.data.total_cost
                        }
                        googleAnalytics.sendLogEvents(eventTypeSimple.purchase, {
                            amount: order_summary.amountDue,
                            value: order_summary.amountDue,
                            currency: orderDetail && orderDetail.currency ? orderDetail.currency : currency_code,
                        })
                        setOrderCache(order_key.order_status, 'DONE', true)
                        setOrderResult(orderDetail.data);
                        setActive('order_result');
                    } else if (result.code == 'MINIMUM_ORDER_AMOUNT_NOT_REACHED') {
                        showMessage(true, t('MINIMUM_ORDER_AMOUNT_NOT_REACHED'))
                    } else if (result.code == 'CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION') {
                        showMessage(true, t('CANNOTEXECUTEACTIONCREDITLIMITEXCEPTION'));
                    } else {
                        showMessage(true, t('EXCEPTION_PROCESS'));
                    }
                } catch (error) {
                    console.log("make order exception:", error);
                    showMessage(true, t('EXCEPTION_PROCESS'));
                }
            }else {
                setPaymentFormData(null);
                onShowPaymentForm(false);

                payload.payments = [{
                    payment_method_type: 'TOKEN',
                    payment_method_id: primary_card.id,
                    payment_token: estimate_order_result.id,
                }];


                var token = newGUID();
                let responseURL = window.location.origin + portalCfg.basename + '/process_order/' + token;

                setOrderCache(order_key.order_token, token);
                var paymentFormResult = await crmservices.orders.createPaymentForm({ estimation_id: estimate_order_result.id, payment_method_id: primary_card.id, redirect_url: responseURL });
                if (paymentFormResult.code == 'OK') {
                    setOrderCache(order_key.cache_order_to_be_process, payload);
                    //console.log("paymentFormResult:",paymentFormResult.data);
                    setPaymentFormData(paymentFormResult.data);
                    onShowPaymentForm(true);
                } else {
                    showMessage(true, t('EXCEPTION_PROCESS'));
                    // }
                } 
            }
        }
        onShowLoading(false);
    }
    const processOrderPaygate = async () => {
        try{
            let urlPortal = window.location.origin;
                var estimate_order_result = getOrderCache(order_key.estimate_order_result);
                if (estimate_order_result) {
                    let totalAmount = 0;
                    let currencyCode = null;
                    if (estimate_order_result.service_delivery_estimate && estimate_order_result.service_delivery_estimate.length > 0) {
                        estimate_order_result.service_delivery_estimate.forEach(service_delivery => {
                            if (service_delivery.billing_estimate) {
                                if (service_delivery.billing_estimate.totals && service_delivery.billing_estimate.totals.total_amount)
                                    totalAmount += service_delivery.billing_estimate.totals.total_amount;
                                let invoicing = service_delivery.billing_estimate.invoicing && service_delivery.billing_estimate.invoicing.length > 0 ? service_delivery.billing_estimate.invoicing[0] : null;
                                if (invoicing) {
                                    currencyCode = invoicing.currency_code ? invoicing.currency_code : null;
                                }
                            }
                        });
                    }
                    let body = {
                        estimate_id: estimate_order_result.id,
                        total_amount: totalAmount.toFixed(2),
                        currency: currencyCode,
                        payment_result_url: urlPortal + paths.paygate_payment_result,
                        payment_redirect_url: document._portalConfig.urlPlugins + "/plugins",
                    };
                    let result = await aynaottservices.initiateOrderPayment(body);
                    console.log("result order paygate===", result);
                    if (result.code === 'OK') {
                        if (result.data && result.data.status === 'SUCCESS') {
                            setOrderCache(order_key.order_status, 'DONE', true)
                            callRefreshMyOrderListeners();
                            clearOrder();
                            callCartItemListeners();
                            if (result.data.redirect_url) window.location.href = result.data.redirect_url;
                        } else {
                            let mess = result.data.failed_reason ? result.data.failed_reason : t('EXCEPTION_PROCESS');
                            showMessage(true, mess);
                        }
                    } else if (result.error && result.error.error === 'CONTACT_ADDRESS_NOT_FOUND') {
                        showMessage(true, t('CONTACT_ADDRESS_NOT_FOUND'));
                    } else if (result.error && result.error.error === 'CONTACT_PHONE_NOT_FOUND') {
                        showMessage(true, t('CONTACT_PHONE_NOT_FOUND'));
                    }
                    else {
                        let mess = result.error && result.error.message ? result.error.message : t('EXCEPTION_PROCESS');
                        showMessage(true, mess);
                    }
                }
        }catch(ex){
            console.log("processOrderPaygate exception===", ex);
        }
    }

    async function delay(time) {
        return new Promise(resolve => setTimeout(resolve, time));
    }
    return (
        <div>
            <CartsView
                open={props.open}
                onClose={props.onClose}
                carts={carts.sort(sortCartByProductName)}
                currency={props.currency}
                estimate_cart_items={estimate_cart_items.sort(sortCartByProductName)}
                estimate_order_result={getOrderCache(order_key.estimate_order_result)}
                totalAmountBaseItem={props.totalAmountBaseItem}
                availabelWalletFund={props.availabelWalletFund}
                onPlaceOrder={onPlaceOrder}
                onGoBack={props.setActivePage}
                onRemoveItem={onRemoveItem}
                editCartItem={props.editCartItem}
                showAddNote={showAddNote}
                onClickAddNote={() => onShowAddNote(!showAddNote)}
                handleOnChangeAddNote={props.handleOnChangeAddNote}
                notes={props.order_notes}
                onUseWalletFund={onUseWalletFund}
                isUseWalletFund={props.isUseWalletFund}
                paymentMethod={props.paymentMethod}
                primary_card={props.primary_card}
                primary_paypal={props.primary_paypal}
                order_type={props.order_type}
                crosssellProducts={crosssellProducts}
                onSelectCrossellProduct={props.onSelectCrossellProduct}
                loadingCrosssell={loadingCrosssell}
                request_amount_from_wallet_funds={request_amount_from_wallet_funds}
                isValidAmountWalletFund={isValidAmountWalletFund}
                edit_amount_form={edit_amount_form}
                // payment_method={payment_method_type}
                payment_method_types={payment_method_types}
                input_field_value={input_field_value}
                cardsStripe={props.cards ? props.cards.filter(card => card.name && card.name.toLowerCase() === 'stripe') : []}
                cardsPaypal={props.cards ? props.cards.filter(card => card.name && card.name.toLowerCase() === 'paypal') : []}
                paymentSelected={paymentSelected}
                onShowEditWalletFundAmount={onShowEditWalletFundAmount}
                handleChangeNumberFund={handleChangeNumberFund}
                onSelectPaymentMethod={onChangePaymentMethod}
                onAddCard={props.onAddCard}
                onChangeCard={props.onChangeCard}
                onItemQuantityChange={onItemQuantityChange}
                setPaymentSelected={setPaymentSelected}
                setPrimaryCard={props.setPrimaryCard}
                setPrimaryPaypal={props.setPrimaryPaypal}
            />
            {showPaymentForm && <PaymentForm
                open={showPaymentForm}
                onClose={() => onShowPaymentForm(false)}
                paymentFormData={paymentFormData}
            />}
            {active == 'order_result' && <OrderResultController
                open={active == 'order_result'}
                onClose={props.onClose}
                order_result={order_result}
            />}
            {active == 'vnpay' && <VNPay
                open={active == 'vnpay'}
                onClose={() => setActive('main')}
                amount={orderSummary.amountDue}
            />}
            {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}
            {showLoading && <Loading showLoading={showLoading}/>}
        </div>
    );
}

export default CartsController;